!function(){"function"!=typeof Object.assign&&(Object.assign=function(n){if(void 0===n||null===n)throw new TypeError("Cannot convert undefined or null to object");for(var o=Object(n),r=1;r<arguments.length;r++){var t=arguments[r];if(void 0!==t&&null!==t)for(var e in t)t.hasOwnProperty(e)&&(o[e]=t[e])}return o})}();



//////////////////
// WEBPACK FOOTER
// C:/Works/Respite/respite_app/UI/~/mdn-polyfills/Object.assign.js
// module id = ../../../../mdn-polyfills/Object.assign.js
// module chunks = 4